import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { refreshHeaderOffset } from './headerLayout';

let initialized = false;

function syncSafeAreaFallback() {
  const root = document.documentElement;
  const visualTop = window.visualViewport
    ? Math.max(0, Math.round(window.visualViewport.offsetTop))
    : 0;

  if (visualTop > 0) {
    root.style.setProperty('--safe-area-top-fallback', `${visualTop}px`);
  } else {
    root.style.removeProperty('--safe-area-top-fallback');
  }
}

export async function initNativeLayout() {
  if (initialized || !Capacitor.isNativePlatform()) {
    return;
  }

  initialized = true;
  document.documentElement.classList.add('native-app');

  try {
    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: '#26272C' });
  } catch (_) {
    // StatusBar plugin unavailable in web builds
  }

  syncSafeAreaFallback();
  refreshHeaderOffset();

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', () => {
      syncSafeAreaFallback();
      refreshHeaderOffset();
    });
    window.visualViewport.addEventListener('scroll', () => {
      syncSafeAreaFallback();
      refreshHeaderOffset();
    });
  }
}
